<script>
import SeriesEnrollmentModal from "components/pages/registration/partials/SeriesEnrollmentModal";
import PrerequisiteNotice from "components/pages/registration/partials/PrerequisiteNotice";

export default {
  methods: {
    enrollMyself(course) {
      if (!!course.series_id) {
        this.showSeriesEnrollment(course, true);
      } else {
        this.goToRoute("enroll.online.course.self", { course: course.id });
      }
    },
    enrollOthers(course) {
      if (!!course.series_id) {
        this.showSeriesEnrollment(course, false);
      } else {
        this.goToRoute("enroll.online.course.others", { course: course.id });
      }
    },
    showSeriesEnrollment(course, self) {
      this.$modal(SeriesEnrollmentModal, { course: course, self: !!self })
        .then(() => {})
        .catch(() => {});
    },
    showPrerequisiteNotice() {
      this.$modal(PrerequisiteNotice)
        .then(() => {})
        .catch(() => {});
    },
    showIncludesNotice() {
      this.$modal(IncludedCoursesNotice)
          .then(() => {})
          .catch(() => {})
    }
  },
};
</script>